import { useEffect } from 'react';
import { useTheme } from '@/hooks/useTheme';

const DECK_EMBED_URL =
  'https://embed.figma.com/deck/kpQYp38bhjAif2lVIfGWhb/Polymyth-Investor-Deck-August-2026?node-id=3003-2&viewport=-128%2C175%2C0.6&scaling=min-zoom&content-scaling=fixed&page-id=0%3A1&embed-host=share';

export default function DeckPage() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  // URL-only page: keep it out of search indexes. robots.txt also disallows
  // /deck, but this tag covers crawlers that reach the URL directly.
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div className="relative flex flex-col items-center px-6 py-12 min-h-[100dvh]">
      <div className="relative z-[3] w-full animate-slide-up-fade space-y-6">
        <div className="flex flex-col items-center gap-3 text-center">
          <img
            src={isDark ? '/polymyth_logo_v1_final_dark.svg' : '/polymyth_logo_v1_final_lite.svg'}
            alt="Polymyth"
            className="h-10 w-auto max-w-full drop-shadow-lg"
          />
          <h1 className="text-3xl text-foreground/90 tracking-wide font-character">
            Pre-Seed Deck
          </h1>
        </div>

        <div className="rounded-2xl border bg-card/60 shadow-lg backdrop-blur-md p-3 sm:p-4">
          <div className="aspect-[16/9] w-full overflow-hidden rounded-lg">
            <iframe
              title="Polymyth Investor Deck"
              src={DECK_EMBED_URL}
              className="h-full w-full border-0"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </div>
  );
}
